import { AxiosResponse } from "axios";
import { ITemplateFoldersResponseData, ICreateTemplateFolderRequest, ICreateTemplateFolderResponseData, IObject } from "../../redux/reducers/ui/uiTypes";
import { studioAxiosInstance } from "./instances";

// Helper function to transform backend response to expected frontend structure
const transformFolderResponse = (data: any[]): ITemplateFoldersResponseData => {
    return {
        count: data.length,
        rows: data.map(folder => ({
            id: folder.id,
            name: folder.name,
            image: folder.image || undefined,
            projects: [],
            children: folder.children || [],
            parent: folder.parent || null
        } as IObject))
    };
};

export const getTemplateFoldersAPI = async (): Promise<AxiosResponse<ITemplateFoldersResponseData>> => {
    const response = await studioAxiosInstance.get(`/templates/folders/`);
    return {
        ...response,
        data: transformFolderResponse(response.data)
    };
};

export const getTemplateFoldersPaginatedAPI = async ({
    page,
    pageSize,
}: {
    page: number;
    pageSize: number;
}): Promise<AxiosResponse<ITemplateFoldersResponseData>> => {
    const response = await studioAxiosInstance.get(
        `/templates/folders/?pageSize=${pageSize}&page=${page}`
    );
    return {
        ...response,
        data: transformFolderResponse(response.data)
    };
};

export const createTemplateFolderAPI = async (
    data: ICreateTemplateFolderRequest
): Promise<AxiosResponse<ICreateTemplateFolderResponseData>> => {
    return await studioAxiosInstance.post(
        `/templates/folders/`,
        data
    );
};

export const updateTemplateFolderAPI = async (
    folderId: number,
    data: ICreateTemplateFolderRequest
): Promise<AxiosResponse<ICreateTemplateFolderResponseData>> => {
    return await studioAxiosInstance.put(
        `/templates/folders/${folderId}`,
        data
    );
};

export const deleteTemplateFolderAPI = async (
    folderId: number
): Promise<AxiosResponse<any>> => {
    return await studioAxiosInstance.delete(
        `/templates/folders/${folderId}`
    );
}; 